export enum TPinType {
  RELATED_ROUTES = 'RELATED_ROUTES',
  PRODUCTS = 'PRODUCTS',
}
